import { NavLink } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Detect test page
  const isTestPage = location.pathname.startsWith("/test-page/");

  // ✅ Hide footer completely
  if (isTestPage) return null;

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      }, 200);
    }
  };
  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="footer_content">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-5">
                <div className="footer_logo_div">
                  <img
                    src="/assets/images/header/logo.png"
                    alt="footer-logo"
                    className="footer_logo"
                    onClick={() => navigate("/")}
                  />
                </div>

                <p className="footer_text">
                  A structured career and parental counselling platform offering
                  assessments, expert guidance, & personalized career planning
                  for students.
                </p>
              </div>

              {/* Quick Links */}
              <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4 mt-3 col_div">
                <h5 className="footer_section_title">Quick Links</h5>
                <div className="footer_links quick_links">
                  {[
                    { label: "Home", path: "/" },
                    {
                      label: "Career Counselling",
                      path: "/career-counselling",
                    },
                    {
                      label: "parental Counselling",
                      path: "/parental-counselling",
                    },
                    { label: "About Us", path: "/about-us" },
                    { label: "Contact Us", path: "/contact-us" },
                    { label: "Blogs", path: "/blogs" },
                  ].map((item) => (
                    <NavLink
                      key={item.path}
                      as={Link}
                      to={item.path}
                      onClick={(e) => handleNavClick(item.path, e)}
                      className={`footer_link ${
                        item.path === "/"
                          ? location.pathname === "/"
                            ? "active_footer_link"
                            : ""
                          : location.pathname.startsWith(item.path)
                          ? "active_footer_link"
                          : ""
                      }`}
                    >
                      {item.label}
                    </NavLink>
                  ))}
                </div>
              </div>

              {/* Support */}
              <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4 mt-3 col_div">
                <h5 className="footer_section_title">Support</h5>
                <div className="footer_links quick_links">
                  {[
                    { label: "FAQ", path: "/faq" },
                    { label: "Terms & Conditions", path: "/terms-conditions" },
                    { label: "Privacy Policy", path: "/privacy-policy" },
                  ].map((item) => (
                    <NavLink
                      key={item.path}
                      as={Link}
                      to={item.path}
                      onClick={(e) => handleNavClick(item.path, e)}
                      className={`footer_link ${
                        item.path === "/"
                          ? location.pathname === "/"
                            ? "active_footer_link"
                            : ""
                          : location.pathname.startsWith(item.path)
                          ? "active_footer_link"
                          : ""
                      }`}
                    >
                      {item.label}
                    </NavLink>
                  ))}
                </div>

                <div className="icon_div">
                  {[
                    {
                      icon: faFacebookF,
                      link: "https://www.facebook.com",
                    },
                    {
                      icon: faInstagram,
                      link: "https://www.instagram.com",
                    },
                    {
                      icon: faWhatsapp,
                      link: "https://wa.me/1234567890", // replace with your number
                    },
                    {
                      icon: faLinkedinIn,
                      link: "https://www.linkedin.com",
                    },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      className="icon_link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="footer_icon"
                        style={{ color: "#000", fontSize: "22px" }}
                      />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
